import * as React from 'react';

import { ProfileContext } from '../../contexts/ProfileProvider';
import { ProfileContextValue } from '../../contexts/ProfileProvider.types';

export function useProfile(): ProfileContextValue {
  const context = React.useContext(ProfileContext);
  if (!context) {
    throw new Error('useProfile must be used within ProfileProvider');
  }

  return context;
}
